module.exports = __webpack_public_path__ + "img/32.550829a0.png";